import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollRestoration = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    /**
     * @NOTE:top is set to 1 intentionally
     * @see https://stackoverflow.com/questions/4117377/how-do-i-hide-the-address-bar-on-iphone
     */
    window.scrollTo({
      top: 1,
      left: 0,
      behavior: 'smooth',
    });
  }, [pathname]);
};
